const cpfOk = (c) => {
  if (/^(\d)\1{10}$/.test(c)) return false;
  return [9, 10].every((i) => {
    const s = [...c.slice(0, i)].reduce((a, n, j) => a + Number(n) * (i + 1 - j), 0);
    return ((s * 10) % 11) % 10 === Number(c[i]);
  });
};

const cnpjOk = (c) => {
  if (/^(\d)\1{13}$/.test(c)) return false;
  const w1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  return [[w1, 12], [[6, ...w1], 13]].every(([w, pos]) => {
    const r = [...c.slice(0, pos)].reduce((a, n, i) => a + Number(n) * w[i], 0) % 11;
    return (r < 2 ? 0 : 11 - r) === Number(c[pos]);
  });
};

export const validDoc = (d) => (d.length === 11 && cpfOk(d)) || (d.length === 14 && cnpjOk(d));
